import type * as Style from '../../index.js'
import { Length } from '../../values/index.js'
import { formatSideDimensions } from '../../../utils/summary.js'

export const Props = (props: any = {}) => ({
  paddingTop: Length(props.paddingTop),
  paddingBottom: Length(props.paddingBottom),
  paddingLeft: Length(props.paddingLeft),
  paddingRight: Length(props.paddingRight),
  rowGap: Length(props.rowGap || props.gap),
  columnGap: Length(props.columnGap || props.gap)
})
export type Props = ReturnType<typeof Props>
export const validate = () => true
export const fix = (props: Props, styles: Style.Rule[]) => props
export const type = 'spacing'
export const label = 'Spacing'
export const property = 'spacingIds'
export const category = 'aspect'
export const forms = [
  {
    label: 'Spacing',
    id: 'spacing',
    extractProperties: Props,
    validate: () => true
  }
]
export const summarize = (props: Props, styles?: Style.Rule[], formId?: string) => {
  const sides = formatSideDimensions(
    props.paddingTop.value + props.paddingTop.unit,
    props.paddingBottom.value + props.paddingBottom.unit,
    props.paddingLeft.value + props.paddingLeft.unit,
    props.paddingRight.value + props.paddingRight.unit
  )

  const gaps =
    props.rowGap.value && props.columnGap.value && props.rowGap.value !== props.columnGap.value
      ? 'Custom'
      : props.rowGap.value > props.columnGap.value
      ? props.rowGap.value + props.rowGap.unit
      : props.columnGap.value + props.columnGap.unit

  return [sides, gaps].filter(Boolean).join(' / ')
}
